import { render, staticRenderFns } from "./BIcon.vue?vue&type=template&id=366cfc4c"
import script from "./BIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./BIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports